import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/MailOutline';
import list from './list';
import show from './show';

const messages: ResourceProps = {
  name: 'messages',
  icon,
  options: { label: 'Mensagens' },
  list,
  show
};

export default messages;
